module.exports = __webpack_public_path__ + "img/phonemockup.a8487639.png";